import React from 'react'
import { connect } from 'react-redux'

import { RootState } from 'store'
import { openComposition as openCompositionAction } from 'models/compositions/actions'
import { openScene as openSceneAction } from 'models/scenes/actions'
import KioskLanding from 'components/KioskLanding'
import OpenCompositionTrackingType from 'models/tracking'
import {
    selectKioskRoomType as selectKioskRoomTypeAction,
    setKioskIntroViewed as setKioskIntroViewedAction,
} from 'models/kiosk/actions'
import { getIsKioskIntroViewed, getKioskSelectedRoomType } from 'models/kiosk/selectors'
import { RoomType } from 'models/kiosk/constants'

interface KioskLandingContainerProps {
    openComposition: (compositionId: number, trackingInfo?: OpenCompositionTrackingType) => void
    openScene: (sceneId: number, trackingInfo?: OpenCompositionTrackingType) => void
    roomType: RoomType
    selectKioskRoomType: (roomType: RoomType) => void
    isKioskIntroViewed: boolean
    setKioskIntroViewed: () => void
}
const KioskLandingContainer = ({ openComposition, openScene, roomType, selectKioskRoomType, isKioskIntroViewed, setKioskIntroViewed }: KioskLandingContainerProps) => (
    <KioskLanding
        openComposition={openComposition}
        openScene={openScene}
        roomType={roomType}
        selectKioskRoomType={selectKioskRoomType}
        isKioskIntroViewed={isKioskIntroViewed}
        setKioskIntroViewed={setKioskIntroViewed}
    />
)

const mapStateToProps = (state: RootState) => ({
    roomType: getKioskSelectedRoomType(state),
    isKioskIntroViewed: getIsKioskIntroViewed(state),
})

const mapDispatchToProps = {
    openComposition: openCompositionAction,
    openScene: openSceneAction,
    selectKioskRoomType: selectKioskRoomTypeAction,
    setKioskIntroViewed: setKioskIntroViewedAction,
}
export default connect(mapStateToProps, mapDispatchToProps)(KioskLandingContainer)
